import { render, staticRenderFns } from "./TargetIcon.vue?vue&type=template&id=fbec8b6e&"
import script from "./TargetIcon.vue?vue&type=script&lang=ts&"
export * from "./TargetIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fbec8b6e', component.options)
    } else {
      api.reload('fbec8b6e', component.options)
    }
    module.hot.accept("./TargetIcon.vue?vue&type=template&id=fbec8b6e&", function () {
      api.rerender('fbec8b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/TargetIcon.vue"
export default component.exports